@if (nodes().length) {
  <nav>
    <ol>
      <!-- Home -->
      <li>
        <a uiNavLink [link]="homeItem()">
          <ui-icon faName="house" faStyle="light"></ui-icon>
        </a>
      </li>

      <!-- Menu -->
      @if (menuItems().length) {
        <li class="has-menu">
          <button (mouseenter)="buttonEnter()" (mouseleave)="buttonLeave()" (touchstart)="buttonTouch()">...</button>
          <div [matMenuTriggerFor]="menu"></div>
        </li>
      }

      <!-- Link -->
      @if (parentItem(); as parentItem) {
        <li>
          @if (parentItem.url) {
            <a uiNavLink [link]="parentItem">{{ parentItem.label }}</a>
          } @else {
            <span>{{ parentItem.label }}</span>
          }
        </li>
      }

      <!-- Current -->
      @if (currentItemTitle(); as title) {
        <li>
          <span class="text-wrapper">{{ title }}</span>
        </li>
      }
    </ol>
  </nav>

  <mat-menu #menu="matMenu" [hasBackdrop]="false">
    @for (item of menuItems(); track item) {
      <a uiNavLink class="menu-item" [link]="item">{{ item.label }}</a>
    }
  </mat-menu>
}
